/* eslint-disable */

const patterns = {
	'post_code': new RegExp(/^\d{2}-\d{3}$/),
	'vat_id': new RegExp(/^[a-zA-Z]{2}?[0-9]{10}$/),
	'email': new RegExp(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
	'decimal': new RegExp(/^(\d+\.?\d{0,9}|\.\d{1,9})$/)
};

const examples = {
	"post_code": "xx-xxx",
	"vat_id": "XX1234567890",
	"email": "example@example.com",
	"required": "Pole wymagane",
	"decimal": "12,22"
};

class validatorDirective {
	constructor() {
		"ngInject";
		this.restrict = "A";
	}

	/**
	 *
	 * @param scope
	 * @param element
	 * @param attribute
	 */
	link(scope, element, attribute) {

		try {
			let formGroup = element.parent(),
				label = formGroup.find("label"),
				input = formGroup.find("input"),
				labelText = null;

			element.on("keyup focus blur", (event) => {
				let validator = attribute.validator,
					pattern = patterns[validator],
					errorText = examples[validator];

				let value = event.currentTarget.value;
				let valid;
				if (validator === "required") {
					valid = !!value.length;
				} else if (validator === "") {
					valid = true;
				} else {
					valid = pattern.test(value);
				}

				if (attribute.min && parseInt(value) < parseInt(attribute.min)) {
					event.currentTarget.value = attribute.min;
				}

				if (attribute.max && parseInt(value) > parseInt(attribute.max)) {
					event.currentTarget.value = attribute.max;
				}

				if (!labelText) {
					labelText = label.text();
				}



				if (valid) {
					input.removeAttr("placeholder");
					formGroup.removeClass("has-error");
				} else {
					input.attr("placeholder", errorText);
					formGroup.addClass("has-error");
				}

			});
		} catch (e) {
			console.log(e);
		}

	}

	static create() {
		return new validatorDirective();
	}

}

class validatorButtonDirective {
	constructor() {
		"ngInject";
		this.restrict = "A";
	}

	/**
	 *
	 * @param scope
	 * @param element
	 * @param attribute
	 */
	link(scope, element, attribute) {

		let container = $(`form[name="${attribute.validatorButton}"]`),
			parentScope = attribute.validatorButton.split("_")[0];

		if (!container.length) {
			container = $(`[id="${attribute.validatorButton}"]`);
		}

		element.on("click", (e) => {
			let inputs = container.find("input.form-control").not(".ng-hide");

			try {
				scope.$parent[parentScope].formIsValid = true;
			} catch (e) {
			}

			let typeheads = container.find(".ui-select-container").not(".ng-hide");

			angular.forEach(inputs, ( input ) => {
        if(input){
          input.focus();
        }
      } );

			angular.forEach(typeheads, (typehead) => {
				let _t = angular.element(typehead);
				if (_t.hasClass("ng-not-empty") || _t.attr("validator-select") == "false") {
					_t.removeClass("has-error");
				} else {
					_t.addClass("has-error");
				}
			});

			if (container.find(".has-error").length) {

				container.find('.has-error input:visible')[0].focus();

				try {
					scope.$parent[parentScope].formIsValid = false;
				} catch (e) {
				}

				e.preventDefault();
				e.stopPropagation();

				return false;
			}

		});

	}

	static create() {
		return new validatorButtonDirective(...arguments);
	}
}

class validatorSelectDirective {
	constructor() {
		"ngInject";
		this.restrict = "A";
		this.require = "uiSelect";
	}

	link(scope, element, attributes, $select) {

		if (attributes.validatorSelect == "false") {
			return false;
		}

		let selected, focus;
		scope.$watchGroup(["$select.selected", "$select.focus"], function (data) {
			selected = data[0];
			focus = data[1];
			if (!selected && focus) {
				element.addClass("has-error");
			}
			if (typeof selected === "object" && focus) {
				element.removeClass("has-error");
			}
		});
	}

	static create() {
		return new validatorSelectDirective(...arguments);
	}
}

class validateJsonDirective {

	constructor() {
		this.restrict = "A";
		this.require = "ngModel";
	}

	link(scope, element, attr, ctrl) {

		const customValidator = (ngModelValue) => {
			try {
				if (ngModelValue !== undefined && ngModelValue !== "" && ngModelValue !== null) {
                    JSON.parse(ngModelValue);
                    ctrl.$setValidity('jsonValidator', true);
                } else {
					ctrl.$setValidity('jsonValidator', true);
				}
			} catch (e) {
				ctrl.$setValidity('jsonValidator', false);
			}
			return ngModelValue;
		};

		ctrl.$parsers.push(customValidator);

	}

	static create() {
		return new validateJsonDirective(...arguments);
	}

}



export {validatorButtonDirective};
export {validatorDirective};
export {validatorSelectDirective};
export {validateJsonDirective};


// WEBPACK FOOTER //
// ./sources/directives/validator.directives.js